import {useTranslations} from "next-intl";
import {ThemeService} from "@/src/services/theme";
import {Button, Card, Flex, List} from "antd";
import React, {CSSProperties} from "react";
import {Lodging} from "@/src/entities/lodging";
import bathroom from "@/public/assets/portfolio/icons/bathroom.svg";
import bed from "@/public/assets/portfolio/icons/bed.svg";
import size from "@/public/assets/portfolio/icons/size.svg";
import Icon from "@ant-design/icons";
import {useRouter} from "@/src/i18n/routing";
import {Constants} from "@/src/lib/constants";

type Props = {
    lodgingList: Lodging[]
}
const LodgingsComponent = (props: Props) => {

    const localization = useTranslations('lodgings');
    const themeColors = ThemeService.getThemeColors()
    const router = useRouter()

    const iconStyle: CSSProperties = {
        fontSize: 20
    }

    const goToLodging = (item: Lodging) => {
        router.push(`lodging?id=${item.id}`)
    }

    return (
        <div style={{padding:"40px 0"}}>
            <List
                style={{margin: 16}}
                grid={{
                    gutter: 24,
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                    xl: 2,
                    xxl: 4,
                }}
                dataSource={props.lodgingList}
                renderItem={(item) => (
                    <List.Item>
                        <Card
                            cover={<img alt="" src={item.previewImage} />}
                            hoverable
                            onClick={() => goToLodging(item)}
                        >
                            <Flex vertical={false} align={"center"} justify={"space-between"} style={{marginBottom: 10}}>
                                <h4 className="lodgingTitle">{item.name}</h4>
                                <Button color={"danger"} variant={"outlined"} onClick={(event)=>{
                                    event.stopPropagation()
                                    let link: string = ""
                                    switch (item.id) {
                                        case "lodging1":
                                            link = Constants.happyRentalLodging1Link
                                            break
                                        case "lodging2":
                                            link = Constants.happyRentalLodging2Link
                                            break
                                        case "lodging3":
                                            link = Constants.happyRentalsLink
                                            break
                                        case "lodging4":
                                            link = Constants.happyRentalLodging4Link
                                            break
                                    }
                                    window.open(link, "_blank")
                                }}>{localization("reservation")}</Button>
                            </Flex>
                            <p style={{marginBottom: 25, fontSize: 18, color: "#888"}}>{item.shortDescription}</p>
                            <Flex vertical={false} gap={30}>
                                <Flex vertical={false} gap={4}>
                                    <Icon component={bed} style={iconStyle} />
                                    <p>{`${item.beds} ${localization("beds")}`}</p>
                                </Flex>
                                <Flex vertical={false} gap={4}>
                                    <Icon component={bathroom} style={iconStyle} />
                                    <p>{`${item.bathrooms} ${localization("bathrooms")}`}</p>
                                </Flex>
                                <Flex vertical={false} gap={4}>
                                    <Icon component={size} style={iconStyle} />
                                    <p>{`${item.size} ${localization("size")}`}</p>
                                </Flex>
                            </Flex>
                        </Card>
                    </List.Item>
                )}
            />


        </div>

    )
}

export default LodgingsComponent